import React from "react";

import { useDropzone } from "react-dropzone";

import type { DocumentUploadResponse } from "../../api";

type DragAndDropVersionsProps = {
  selectedId: string;
  postVersion: (selectedId: string, data: File) => Promise<DocumentUploadResponse | undefined>;
  updateMetaVersion?: (modelId: string, newModelId: string) => Promise<void>;
  onUpdateVersion?: (newFileId: string) => void;
};

const DragAndDropVersions = React.memo<DragAndDropVersionsProps>(({ selectedId, onUpdateVersion, postVersion, updateMetaVersion }) => {
  const [isShow, setIsShow] = React.useState<boolean>(false);

  React.useEffect(() => {
    const onDragStart = () => setIsShow(true);
    const onDragEnd = () => setIsShow(false);

    document.getElementById("root")!.addEventListener("mouseenter", onDragEnd, false);
    document.getElementById("root")!.addEventListener("mouseleave", onDragEnd, false);
    window.addEventListener("mouseup", onDragEnd, false);
    window.addEventListener("dragenter", onDragStart, false);
    window.addEventListener("drop", onDragEnd, false);

    return () => {
      document.getElementById("root")!.removeEventListener("mouseenter", onDragEnd, false);
      document.getElementById("root")!.removeEventListener("mouseeleave", onDragEnd, false);
      document.removeEventListener("mouseup", onDragEnd, false);
      document.removeEventListener("dragenter", onDragStart, false);
      document.removeEventListener("drop", onDragEnd, false);
    };
  }, []);

  const onDrop = React.useCallback(
    async (acceptedFiles: File[]) => {
      const droppedFile = acceptedFiles[0];
      if (!droppedFile) {
        return;
      }

      const version = await postVersion(selectedId, droppedFile);

      if (version) {
        onUpdateVersion?.(version.fileMeta.id);
        if (updateMetaVersion) {
          await updateMetaVersion(selectedId, version.fileMeta.id);
        }
      }
    },
    [postVersion, selectedId, onUpdateVersion, updateMetaVersion],
  );
  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop, noClick: true });

  return (
    <div className="absolute inset-0 z-10" {...getRootProps()} style={{ display: isShow ? "block" : "none" }}>
      <input {...getInputProps()} />
      <div className="absolute inset-0 z-10 mt-[5.3125rem] bg-gray-200 bg-opacity-25 p-4">
        <div className="flex h-full items-center justify-center rounded-lg border-4 border-dashed bg-gray-200 bg-opacity-25">
          {isDragActive ? "Отпустите файл для загрузки" : "Поместите файл в рамку для загрузки"}
        </div>
      </div>
    </div>
  );
});

export default DragAndDropVersions;
